"use client";

import { Message } from "@/lib/core/crm/types";
import { MessageActionHandlers } from "./hooks/useMessageActionHandlers";
import { MessageDesktopInlineActions } from "./MessageDesktopInlineActions";

interface MessageDesktopActionsProps {
  message: Message;
  handlers: MessageActionHandlers;
  onCopyLink?: () => void;
  onSaveAttachmentsToGoogleDrive?: () => void;
  className?: string;
}

export function MessageDesktopActions({
  message,
  handlers,
  onCopyLink,
  onSaveAttachmentsToGoogleDrive,
  className,
}: MessageDesktopActionsProps) {
  return (
    <MessageDesktopInlineActions
      message={message}
      handlers={handlers}
      onCopyLink={onCopyLink}
      onSaveAttachmentsToGoogleDrive={onSaveAttachmentsToGoogleDrive}
      className={className}
    />
  );
}
